import { useCallback } from "react";

import dayjs from "@/lib/dayjs";

export const useHandleDate = () => {
	/**
	 * 日付の桁数を揃える
	 */
	const onAddPrefixZeroForDateText = useCallback((date: number) => {
		return date.toString().padStart(2, "0");
	}, []);

	/**
	 * 日付のテキストをフォーマットする（YYYY-MM-DD）
	 */
	const onFormatDateText = useCallback(
		({ year, month, date }: { year: number; month: number; date: number }) => {
			const monthText = onAddPrefixZeroForDateText(month);
			const dateText = onAddPrefixZeroForDateText(date);

			return `${year}-${monthText}-${dateText}`;
		},
		[onAddPrefixZeroForDateText],
	);

	/**
	 * カレンダーの日付リストを生成する
	 */
	const onGenerateCalendarDateList = useCallback((year: number, month: number): Array<number | undefined> => {
		const currentDate = dayjs(`${year}-${month}-01`);

		// 月末の日にち
		const endDate = currentDate.endOf("month").get("date");
		// 月初の曜日
		const startWeekday = currentDate.startOf("month").get("day");

		const dataList = [];
		// 月の初めの日までは undefined
		for (let i = 0; i < startWeekday; i++) {
			dataList.push(undefined);
		}

		// 日付を追加
		for (let h = 1; h <= endDate; h++) {
			dataList.push(h);
		}

		return dataList;
	}, []);

	return {
		// 日付のテキストをフォーマット
		onFormatDateText,
		// カレンダーの日付リストを生成
		onGenerateCalendarDateList,
	};
};
